"use strict";
// (C) 2023 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePermissionsDropdownState = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
exports.usePermissionsDropdownState = function () {
    var _a = tslib_1.__read(react_1.useState(false), 2), isOpen = _a[0], setIsOpen = _a[1];
    var toggleOpen = react_1.useCallback(function () { return setIsOpen(!isOpen); }, [isOpen]);
    return { isDropdownOpen: isOpen, toggleDropdown: toggleOpen };
};
//# sourceMappingURL=usePermissionsDropdownState.js.map